export default __webpack_public_path__ + "static/media/customs.beb7efbf.png";